import { render } from "./FrisbuyGalleryPost.vue?vue&type=template&id=60708804&scoped=true"
import script from "./FrisbuyGalleryPost.vue?vue&type=script&lang=js"
export * from "./FrisbuyGalleryPost.vue?vue&type=script&lang=js"

import "./FrisbuyGalleryPost.vue?vue&type=style&index=0&id=60708804&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60708804"]])

export default __exports__